<template>
  <OnboardingFeatureView
    ref="elRef"
  >
    <p>
      Get notified when players update their status
    </p>
    <PushNotification
      :isVisible="isStatusNotificationVisible"
    >
      {{ topPlayer?.name || player.name }} is in for tomorrow’s run. 3&nbsp;more&nbsp;needed.
    </PushNotification>
    <p>
      or when you have enough numbers to play
    </p>
    <PushNotification
      :body="`10 in and 1 maybe for tomorrow’s run at Brooklyn Bridge Park. Game on!`"
      :isVisible="isSummaryNotificationVisible"
    />
    <p>
      and automatically mute notifications when you’re out
    </p>
  </OnboardingFeatureView>
</template>

<script setup lang="ts">
import PushNotification from "@/components/PushNotification.vue";
import useIntersectionDetection from "@/composables/useIntersectionDetection.ts";
import { topPlayerMap } from "@shared/lib/constants/players.ts";
import { Theme } from "@shared/lib/constants/themes.ts";
import { TablesInsert } from "@shared/lib/database/database.types.ts";
import delay from "@shared/lib/utils/async/delay.ts";
import { computed, ref, useTemplateRef } from "vue";
import OnboardingFeatureView from "./OnboardingFeatureView.vue";

const player = defineModel<TablesInsert<"players">>("player", {
  required: true,
});

const isStatusNotificationVisible = ref(false);
const isSummaryNotificationVisible = ref(false);

const elRef = useTemplateRef<InstanceType<typeof OnboardingFeatureView>>("elRef");
useIntersectionDetection(elRef, async (isIntersecting) => {
  if (isIntersecting) {
    await delay(100);
    isStatusNotificationVisible.value = true;
    await delay(500);
    isSummaryNotificationVisible.value = true;
  }
});

const topPlayer = computed(() => {
  return topPlayerMap.get((player.value?.theme ?? Theme.LosAngelesLakers) as keyof typeof Theme);
});
</script>
